<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Informe De Póliza Tradicional
        </v-card-title>
        <v-container fluid grid-list-sm>
            
            <v-row dense>
                <v-col cols="12" sm="12">
                    <ModalInformePolizaTradicionalComponent :open="obModal.open" :listGeneral="listGeneral" :obModal="obModal"/>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Aseguradora *" color="textbox" v-model="obSearch.idAseguradora"
                        :items="listGeneral.listAseguradora" @change="onListarSeguro" outlined dense />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Seguro *" color="textbox" v-model="obSearch.idSeguro"
                        :items="listGeneral.listSeguro"  outlined dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="N° Póliza" color="textbox" v-model="obSearch.poliza" dense outlined />
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                        :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado" outlined
                        dense />
                </v-col>
                <v-col cols="12" sm="4">
                    <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn fab dark small color="primary" @click="onListar" v-on="on"
                                    :disabled="disabled">
                                    <v-icon dark>search</v-icon>
                            </v-btn>
                        </template>
                        <span>Buscar</span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="6"></v-col>
                <v-col v-else cols="12" sm="6">
                    <v-btn rounded color="primary" dark @click="exportar('table','Informe de Póliza Tradicional')">Exportar a XLSX</v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                        prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera" 
                        :items="listGeneral.detalle" class="elevation-3" id="table">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                <v-icon small>visibility</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'InformePolizaTradicionalView',
        components:{
            ModalInformePolizaTradicionalComponent: () => import('@/components/consulta/informe/ModalInformePolizaTradicionalComponent.vue')
        },
        data: () => ({
            disabled:false,
            obSearch:{
                search:'',
                idAseguradora:null,
                idSeguro:null,
                idCanal:null,
                idEstado:null,
                isDet:false
            },
            obModal:{
                open:false,
                titulo:''
            },
            listGeneral:{},
            parametros:{}
        }),
        created(){
            var error = 'E';

            axios.post(`${BASE_URI}administrador/informe-poliza-tradicional/cargaGeneral`)
                 .then((r)=>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                        this.obSearch.idCanal = _.toString(this.parametros.id_tipo_canal_tradicional);
                        this.obSearch.idAseguradora = _.get(this.listGeneral,['listAseguradora','1','value'],null);
                        this.onListarSeguro('L');
                 })
                 .catch((e)=>{
                    mensajesAlerta(e,error);
                 });
        },
        methods:{
            onListarSeguro(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    var o = {
                        opcion:'LISTAR_SEGURO_X_ASEGURADORA_CANAL',
                        idCanal: this.obSearch.idCanal,
                        idAseguradora: _.isNull(this.obSearch.idAseguradora) ? '' : this.obSearch.idAseguradora,
                        idEstado: this.parametros.id_estado_default
                    }

                    this.$set(this.listGeneral,'listSeguro',[]);

                    axios.post(`${BASE_URI}administrador/poliza/listar`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                var l = [];
                                this.listGeneral.listSeguro.push({value:null,text:"Todos"});
                                _.forEach(r.data.data,(v)=>{
                                    this.listGeneral.listSeguro.push({ text:v.seguro, value:v.idSeguro });
                                });
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            onListar(event){
                if(!_.isUndefined(event)){
                    this.disabled = true;
                    var error = 'E';
                    this.$set(this.listGeneral,'detalle',[]);

                    axios.post(`${BASE_URI}administrador/informe-poliza-tradicional/listar`,_.merge({opcion:'LISTAR'},_.omit(this.obSearch,['search'])))
                        .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                                this.$set(this.listGeneral,'detalle',r.data.data);
                                this.disabled = false;
                        })
                        .catch((e)=>{
                            this.disabled = false;
                            mensajesAlerta(e,error);
                        });
                }
            },
            ver(v){
                this.disabled = true;
                var error = 'E';
                var o = _.merge({opcion:'LISTAR_DETALLE',isDet:true,idCertificado:v.idCertificado,idPoliza:v.idPoliza});
                this.close();

                axios.post(`${BASE_URI}administrador/informe-poliza-tradicional/listar`,o)
                    .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion) }
                            this.obModal = _.merge({open:true,titulo:'Información de Póliza'},r.data.data.data);
                            this.listGeneral.detalleModal = r.data.data.detalleModal;
                            this.listGeneral.listDocumentos = r.data.data.listDocumentos;
                            this.disabled = false;

                    })
                    .catch((e)=>{
                        this.disabled = false;
                        mensajesAlerta(e,error);
                    });
            },
            close(){
                this.obModal = {
                    open:false,
                    titulo:'Información de Póliza'
                }

                this.listGeneral.listDocumentos = [];
                this.listGeneral.detalleModal = [];
            }
        },
        provide(){
            return{
                close:this.close
            }
        }
    }
</script>
